<template>
  <base-wrapper
    :component="VRow"
    v-bind="mergedAttrs"
    v-on="$listeners"
  >
    <slot />

    <template
      #default
    >
      <slot
        name="default"
      />
    </template>
  </base-wrapper>
</template>

<script>
import BaseWrapper from './BaseWrapper.vue'
import { VRow } from 'vuetify/lib/components'

export default {
  name: 'VRowWrapper',

  components: {
    BaseWrapper
  },

  props: {
    /**
     * Applies the align-items CSS property. Available options are start, center, end, baseline and stretch.
     */
    align: {
      type: String,
      default: undefined
    },
    /**
     * Applies the align-content CSS property. Available options are start, center, end, space-between, space-around and stretch.
     */
    alignContent: {
      type: String,
      default: undefined
    },
    /**
     * Changes the align-content property on large and greater breakpoints.
     */
    alignContentLg: {
      type: String,
      default: undefined
    },
    /**
     * Changes the align-content property on medium and greater breakpoints.
     */
    alignContentMd: {
      type: String,
      default: undefined
    },
    /**
     * Changes the align-content property on small and greater breakpoints.
     */
    alignContentSm: {
      type: String,
      default: undefined
    },
    /**
     * Changes the align-content property on extra large and greater breakpoints.
     */
    alignContentXl: {
      type: String,
      default: undefined
    },
    /**
     * Changes the align-items property on large and greater breakpoints.
     */
    alignLg: {
      type: String,
      default: undefined
    },
    /**
     * Changes the align-items property on medium and greater breakpoints.
     */
    alignMd: {
      type: String,
      default: undefined
    },
    /**
     * Changes the align-items property on small and greater breakpoints.
     */
    alignSm: {
      type: String,
      default: undefined
    },
    /**
     * Changes the align-items property on extra large and greater breakpoints.
     */
    alignXl: {
      type: String,
      default: undefined
    },
    /**
     * Reduces the gutter between v-cols.
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Applies the justify-content CSS property. Available options are start, center, end, space-between and space-around.
     */
    justify: {
      type: String,
      default: undefined
    },
    /**
     * Changes the justify-content property on large and greater breakpoints.
     */
    justifyLg: {
      type: String,
      default: undefined
    },
    /**
     * Changes the justify-content property on medium and greater breakpoints.
     */
    justifyMd: {
      type: String,
      default: undefined
    },
    /**
     * Changes the justify-content property on small and greater breakpoints.
     */
    justifySm: {
      type: String,
      default: undefined
    },
    /**
     * Changes the justify-content property on extra large and greater breakpoints.
     */
    justifyXl: {
      type: String,
      default: undefined
    },
    /**
     * Removes the gutter between v-cols.
     */
    noGutters: {
      type: Boolean,
      default: false
    },
    /**
     * Specify a custom tag used on the root element.
     */
    tag: {
      type: String,
      default: 'div'
    }
  },

  computed: {
    VRow () {
      return VRow
    },

    mergedAttrs () {
      return {
        ...this.$props,
        ...this.$attrs
      }
    }
  }
}
</script>
